import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { Container, ContainerContent, ContainerHeader, ContainerTitle } from '@/components/ui/Container'

interface Props {
  organizationId?: string
  workflowId?: string
  title: string
  description?: string
  children: React.ReactNode
}

/** Shared frame for the three setup pages: back to the overview, then one card. */
export function SetupPageShell({ organizationId, workflowId, title, description, children }: Props) {
  return (
    <div className="container mx-auto max-w-3xl py-4">
      <Link
        to={`/admin/organizations/${organizationId}/workflows/${workflowId}/setup`}
        className="mb-4 inline-flex items-center gap-1 text-sm text-on-canvas-muted hover:text-on-canvas"
      >
        <ChevronLeft className="h-4 w-4" />
        Workflow setup
      </Link>

      <Container>
        <ContainerHeader>
          <ContainerTitle>{title}</ContainerTitle>
          {description && <p className="text-sm text-gray-400">{description}</p>}
        </ContainerHeader>
        <ContainerContent>{children}</ContainerContent>
      </Container>
    </div>
  )
}
